import React from 'react'

function H1({text, id}) {
  return (
    <div className='flex text-4xl font-titan uppercase py-6 mt-10 opacity-90' id={id}>{text}</div>
  )
}

export default H1